// @core/api/endpoints/document/delete_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/document';

/**
 * Delete numbering scheme
 * Deletes a numbering scheme. Existing document numbers are not affected.
 */
export async function DeleteNumberingScheme(
  scheme_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
